/* global PAYPAL_CLIENT_ID */

// Shared script URLs for the PayPal/Braintree handshake. Consumed by
// Checkout, ReviewOrder, and the generic PaypalButton via
// withAsyncScriptLoader.
//
// The PayPal SDK can only be loaded in ONE mode per page:
//   * one-time `intent=authorize` (cart purchases, Lifetime)
//   * vault `vault=true&intent=tokenize` (recurring subscriptions —
//     needs a PayPal Billing Agreement for the next billing cycle)
//
// The mode in the SDK URL MUST match the `flow`/`intent` passed to
// paypalCheckoutInstance.createPayment in reduxModules/utils/paypalFlow;
// PayPal throws "Expected intent from order api call to be <x>, got <y>"
// when they disagree.

const braintreeCdnScripts = [
  'https://js.braintreegateway.com/web/3.141.0/js/client.min.js',
  'https://js.braintreegateway.com/web/3.141.0/js/paypal-checkout.min.js',
  'https://js.braintreegateway.com/web/3.141.0/js/vault-manager.min.js'
]

const paypalSdkBase = `https://www.paypal.com/sdk/js?client-id=${PAYPAL_CLIENT_ID}&currency=USD`

// Lifetime needs Pay Later messaging; cart doesn't but the extra component
// is harmless. Both render as one-time orders, so intent=authorize.
const paypalSdkCheckoutUrl = `${paypalSdkBase}&components=buttons,messages&enable-funding=paylater&intent=authorize`

// Recurring subscriptions: PayPal Billing Agreement vault flow. No Pay
// Later (not applicable to recurring) and no `messages` component is
// rendered on subscription checkout (PayPalMessages is Lifetime-only).
const paypalSdkVaultUrl = `${paypalSdkBase}&components=buttons&vault=true&intent=tokenize`

export const paypalScriptsCheckout = [
  paypalSdkCheckoutUrl,
  ...braintreeCdnScripts
]

export const paypalScriptsVault = [paypalSdkVaultUrl, ...braintreeCdnScripts]

// True iff this page should load the PayPal SDK in vault mode (recurring
// subscription that is NOT the Lifetime one-time purchase).
export const isVaultSubscriptionContext = ({ isSubscribing, planSelected } = {}) =>
  Boolean(isSubscribing) && planSelected?.name !== 'Lifetime'

// Selector for HOC consumers: pass this to withAsyncScriptLoader to pick
// the right script set at render time based on the wrapped component's
// own props.
export const selectPaypalScripts = (props) =>
  (isVaultSubscriptionContext(props) ? paypalScriptsVault : paypalScriptsCheckout)

export default paypalScriptsCheckout
